export const faqs = [
  {
    id: 1,
    question: "爆料51 是什么样的平台？",
    answer:
      "爆料51 是面向全网开放的公众线索征集平台。我们汇聚来自网友的真实线索，围绕民生、消费、环境、财经等公共议题进行梳理与核实，并通过悬赏机制鼓励知情者提供有价值的信息，让真相浮出水面。",
  },
  {
    id: 2,
    question: "提交线索会泄露我的身份吗？",
    answer:
      "平台采用来源保护机制：提交信息默认脱敏处理，仅线索核实人员按权限访问，不会在页面公开你的联系方式。你也可以选择只提供关键资料而不留个人姓名，我们会以匿名编号的方式与你对接。",
  },
  {
    id: 3,
    question: "什么样的线索更容易被采纳？",
    answer:
      "真实、可核实、涉及公众利益的线索更容易被采纳。若能提供时间、地点、涉及对象以及凭证材料（如照片、录音、合同、流水等），核实效率会大幅提升，悬赏等级也会相应提高。",
  },
  {
    id: 4,
    question: "悬赏金额是如何确定的？",
    answer:
      "悬赏金额依据线索的完整度、可核实性、涉及范围与社会影响综合评定，分为 S、A、B 三个等级。线索经初步核实后，我们会主动与你沟通悬赏标准与后续对接方式。",
  },
  {
    id: 5,
    question: "提交之后多久能收到反馈？",
    answer:
      "线索提交后，核实团队通常在 48 小时内完成初步评估。若线索进入深度核实流程，我们会通过你预留的联系方式进一步沟通，并同步进展状态。",
  },
  {
    id: 6,
    question: "哪些内容不会被采纳？",
    answer:
      "涉及他人隐私且与公共利益无关的信息、缺乏依据的猜测与传闻、针对个人的恶意攻击，以及任何违反法律法规的内容，均不会进入核实流程。我们鼓励理性、真实、有据可查的线索。",
  },
];